import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { useRef } from 'react';

// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Popper, Tooltip } from '@crehana/ui';
import { clsx } from 'clsx';
import SubMenuDesktopLink from "./SubMenuDesktopLink";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var CollapsedLink = function CollapsedLink(_ref) {
  var menuLink = _ref.menuLink,
    isDark = _ref.isDark,
    isOpened = _ref.isOpened,
    onClickOutside = _ref.onClickOutside,
    isHovered = _ref.isHovered,
    _onClickItem = _ref.onClickItem,
    onMouseEnter = _ref.onMouseEnter,
    onMouseLeave = _ref.onMouseLeave,
    toggleDropdown = _ref.toggleDropdown,
    isSelected = _ref.isSelected,
    currentActive = _ref.currentActive;
  var buttonCollapsedRef = useRef(null);
  var nested = menuLink.nested;
  var hasNestedRoutes = nested && nested.length > 0;
  var ActiveIcon = menuLink.activeIcon || menuLink.icon;
  var getTopPositionElement = function getTopPositionElement() {
    var buttonCollapsed = buttonCollapsedRef.current;
    if (!buttonCollapsed) {
      return 0;
    }
    var _buttonCollapsed$getB = buttonCollapsed.getBoundingClientRect(),
      top = _buttonCollapsed$getB.top;
    return top;
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Tooltip, {
      position: "right",
      isDark: !isDark,
      label: menuLink.tooltip || menuLink.label,
      children: /*#__PURE__*/_jsx("button", {
        type: "button",
        className: "w-full",
        ref: buttonCollapsedRef,
        onClick: toggleDropdown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        children: /*#__PURE__*/_jsx("div", {
          className: clsx('tw-flex tw-items-center tw-justify-center tw-w-4.8 tw-h-4.8 tw-mx-auto tw-my-0.4 tw-rounded-[5px]', isDark ? 'hover:bg-gray-lighter-dark-mode' : 'hover:bg-gray-lighter', {
            'bg-gray-lighter text-primary-main shadow-tooltip': isSelected && !isDark,
            'text-gray-dark': !isSelected && !isDark,
            'text-secondary-main bg-gray-main-dark-mode shadow-tooltip': isSelected && isDark,
            'text-gray-main': !isSelected && isDark
          }),
          children: /*#__PURE__*/_jsx(ActiveIcon, {
            size: 20,
            className: clsx('tw-fill-current', isHovered ? ' tw-text-primary-light-500 dark:tw-text-secondary-dark-400' : 'tw-text-neutral-light-700 dark:tw-text-neutral-dark-300'),
            ignoreColor: true
          })
        })
      })
    }), hasNestedRoutes && /*#__PURE__*/_jsx(Popper, {
      anchorRef: buttonCollapsedRef,
      isVisible: isOpened,
      isDark: isDark,
      position: "right",
      dismissOnClickOutside: true,
      className: "flex",
      onDismiss: onClickOutside,
      setPosition: function setPosition(s) {
        var top = getTopPositionElement();
        return _objectSpread(_objectSpread({}, s), {}, {
          left: 112,
          top: top
        });
      },
      children: /*#__PURE__*/_jsx("div", {
        className: "tw-p-1.2",
        children: /*#__PURE__*/_jsx("ul", {
          className: "tw-block tw-w-full tw-pt-0.4",
          children: nested.map(function (subRoute) {
            return /*#__PURE__*/_jsx(SubMenuDesktopLink, {
              code: subRoute.code,
              label: subRoute.label,
              url: subRoute.url,
              isDark: isDark,
              isSelectedURL: Boolean(currentActive && currentActive.code === subRoute.code),
              onClickItem: function onClickItem() {
                if (subRoute.url) {
                  _onClickItem && _onClickItem(subRoute.url);
                }
              },
              decorationType: "none"
            }, subRoute.code);
          })
        })
      })
    })]
  });
};
export default CollapsedLink;